module.exports = __webpack_public_path__ + "static/feedterminal-b8dd9b84da4be98185a5cdad81ddd201.jpg";